import ParamsEditor from './ParamsEditor';

export default ParamsEditor;
